import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@paygreen/paygreen-ui';

const ProjectCardSkeleton = ({ lineNumber, repeat }) => (
    <>
        {[...Array(repeat)].map((el, index) => (
            <Skeleton
                key={index}
                skeletonType="imageCard"
                blockWidth="md"
                shadowSize="md"
                radiusSize="sm"
                colorWab="grey20"
                backgroundColor="white00"
                lineNumber={lineNumber}
                hasResponsivePadding={true}
                padding="lg"
            />
        ))}
    </>
);

ProjectCardSkeleton.propTypes = {
    lineNumber: PropTypes.number,
    repeat: PropTypes.number,
};

ProjectCardSkeleton.defaultProps = {
    lineNumber: 3,
    repeat: 2,
};

export default ProjectCardSkeleton;
